// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__dRlwZ","item":"styles_item__m51XN","question":"styles_question__7Sciz","text":"styles_text__zXYje","arrow":"styles_arrow__3ZTmB"};